import React from 'react';

function AccessDenied() {
    return (
        <div className="container text-center mt-5">
            <div className="card p-5">
                <h1 className="mb-4">Access Denied</h1>
                <p className="lead">This application is only accessible through Telegram.</p>
                <p>Please use our Telegram bot to access this service.</p>
            </div>
        </div>
    );
}

export default AccessDenied; 